import * as React from 'react';
import styled from 'styled-components';
import * as _ from 'lodash/fp';

import { Checkbox } from '@process-advisor/process-miner/components/shared/checkbox';
import { type StartLabelProps } from '@process-advisor/process-miner/api/methods/settings/changeStartEndLabels';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
`;

export const StartLabel = () => {
    const [StartLabel, setStartLabel] = React.useState<StartLabelProps>({});
    const onChange = _.curry((
        key: keyof StartLabelProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const newStartLabel = { ...StartLabel, [key]: e.target.checked };
        setStartLabel(newStartLabel);
        apiProvider.changeStartLabel(newStartLabel);
        apiProvider.rebuildPVDiagram({});
    });

    React.useEffect(() => {
        setStartLabel(apiProvider.getStartLabel());
    }, []);

    React.useEffect(() => {
        const listener = () =>
            setStartLabel(apiProvider.getStartLabel());
        listener();

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    return (
        <Wrapper>
            <Checkbox
                label=''
                checked={!!StartLabel.visible}
                handleOnChange={onChange('visible')} />
        </Wrapper>
    );
};
